import React from 'react'

import Base from '../_Base'

const Calendar = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M4,20 L20,20 L20,12 L4,12 L4,20 Z M6,6 L6,7 C6,7.552 6.448,8 7,8 C7.552,8 8,7.552 8,7 L8,6 L16,6 L16,7 C16,7.552 16.447,8 17,8 C17.553,8 18,7.552 18,7 L18,6 L20,6 L20,10 L4,10 L4,6 L6,6 Z M21,4 L18,4 L18,3 C18,2.448 17.553,2 17,2 C16.447,2 16,2.448 16,3 L16,4 L8,4 L8,3 C8,2.448 7.552,2 7,2 C6.448,2 6,2.448 6,3 L6,4 L3,4 C2.448,4 2,4.448 2,5 L2,21 C2,21.553 2.448,22 3,22 L21,22 C21.553,22 22,21.553 22,21 L22,5 C22,4.448 21.553,4 21,4 L21,4 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default Calendar
